export default (state = false, action = {}) => {
  switch (action.type) {
    case 'FORECAST_SAVING':
      return action.payload;
    default:
      return state;
  }
};
